import React, { Component } from "react";
import { Row, Col, Card, Container, Button } from "react-bootstrap";
import classes from "./success.module.css";
import { connect } from "react-redux";
import * as actionTypes from "../../../../Action/Index";
import { NavLink, withRouter, Redirect } from "react-router-dom";
import Cookies from "universal-cookie";
import circle from "../../../../Assets/Images/circle.png";
import exclamation from "../../../../Assets/Images/exclamation.jpg";
import error from "../../../../Assets/Images/exclamation.jpg";
import Loader from "react-loader-advanced";
import NoDataErrorScreen from "../../../commonComponents/NetworkError/NodataError/Nodataerror";
import ServerErrorScreen from "../../../commonComponents/NetworkError/ServerError/Servererror";
import loading from "../../../../Assets/Images/loader-green.gif";
import moment, { weekdays } from "moment";

import Backdrop from "../../../Popup/Backdrop/Backdrop";
import SweetAlert from "../../../commonComponents/SweetAlert";
// const Cryptr = require("cryptr");

class success extends Component {
  state = {
    orderId: null,
    mode: null,
    subscriptionId: -1,
  };

  componentDidMount() {
    //this.props.confirmPaymentStatus(this.state.orderId)
    let date = `${new Cookies().get("CNinterviewDate").split(" ").join("-")}`;
    date = date + "-" + new Date().getFullYear();
    // console.log(date);
    // const cryptr = new Cryptr("foxmatrix#brijesh@atishay$nikhil");
    const bodyFormData = {
      amount: `${
        new Cookies().get("CNamount") < 0 ? 0 : new Cookies().get("CNamount")
      }`,
      candidateNotes: "",
      endTime: new Cookies().get("CNendTime"),
      interviewDate: date,
      interviewerId: new Cookies().get("CNinterviewerId"),
      interviewerNotes: "",
      orderId:
        new Cookies().get("CNorderId") === ""
          ? new Cookies().get("CNorderId")
          : new Cookies().get("CNorderId"),
          // : cryptr.decrypt(new Cookies().get("CNorderId")),
      jobProfileId: new Cookies().get("CNjobId"),
      startTime: new Cookies().get("CNendTime"),
      modeofinterview: new Cookies().get("CNmodeofinterview"),
    };
    this.props.scheduleInterview(bodyFormData);
    //console.log(bodyFormData)
  }

  handleOk = () => {
    new Cookies().remove("CNinterviewerId", {
      path: "/self-assessment",
      expires: "Thu, 01 Jan 1970 00:00:01 GMT",
    });
    new Cookies().remove("CNinterviewerId", {
      path: "/self-assessment/interview",
      expires: "Thu, 01 Jan 1970 00:00:01 GMT",
    });
    new Cookies().remove("CNinterviewDate", {
      path: "/self-assessment/interview",
      expires: "Thu, 01 Jan 1970 00:00:01 GMT",
    });
    new Cookies().remove("CNendTime", {
      path: "/self-assessment/interview",
      expires: "Thu, 01 Jan 1970 00:00:01 GMT",
    });
    new Cookies().remove("CNmodeofinterview", {
      path: "/self-assessment/interview",
      expires: "Thu, 01 Jan 1970 00:00:01 GMT",
    });
    new Cookies().remove("CNjobId", {
      path: "/self-assessment/interview",
      expires: "Thu, 01 Jan 1970 00:00:01 GMT",
    });
    new Cookies().remove("CNamount", {
      path: "/self-assessment/interview",
      expires: "Thu, 01 Jan 1970 00:00:01 GMT",
    });
    new Cookies().remove("CNorderId", {
      path: "/self-assessment/interview",
      expires: "Thu, 01 Jan 1970 00:00:01 GMT",
    });
    this.setState(
      {
        show: false,
      },
      () => this.props.history.push("/interview")
    );
  };

  render() {
    /* Added By Abhishek Srivastava(START) */
    return this.props.scheduleInterviewLoader ? (
      <Loader
        show={true}
        message={<img src={loading} />}
        foregroundStyle={{ color: "#00a99d" }}
        backgroundStyle={{
          backgroundColor: "#F3EFEF",
          width: "100%",
          height: "100vh",
          zIndex: 100,
        }}
      ></Loader>
    ) : this.props.scheduleInterviewEStatus ? (
      <>
        <Backdrop open={this.state.backdrop} />
        <SweetAlert
          type="success"
          show="true"
          msg="Interview Scheduled Successfully"
          handleOk={this.handleOk}
        />
      </>
    ) : (
      <>
        <Backdrop open={this.state.backdrop} />
        <SweetAlert
          type="warning"
          show="true"
          msg={this.props.scheduleInterviewErrorMsg}
          handleOk={this.handleOk}
        />
      </>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    scheduleInterviewEStatus: state.employeeReducer.scheduleInterviewEStatus,
    scheduleInterviewErrorMsg: state.employeeReducer.scheduleInterviewErrorMsg,
    scheduleInterviewLoader: state.employeeReducer.scheduleInterviewLoader,
    scheduleInterviewInterviewerNodata:
      state.employeeReducer.scheduleInterviewInterviewerNodata,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    scheduleInterview: (orderId) =>
      dispatch(actionTypes.scheduleInterview(orderId)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(success));
